import { render, staticRenderFns } from "./ConsumerCouponsManager.vue?vue&type=template&id=3ac41ab4"
import script from "./ConsumerCouponsManager.vue?vue&type=script&lang=js"
export * from "./ConsumerCouponsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports